var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEstliveicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 16,
    viewBox: "0 0 25 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00341797 13.8322C0.0232285 14.7312 0.756623 15.45 1.65578 15.4518H22.3558C23.2703 15.4518 24.0118 14.7103 24.0118 13.7958V2.38232L0.00341797 13.8322Z",
    fill: "#C32F22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.012 2.20385C24.012 1.28933 23.2705 0.547852 22.356 0.547852H1.656C0.74148 0.547852 0 1.28933 0 2.20385V13.7959C0 13.8082 0.00323438 13.8199 0.00363867 13.8322L24.012 2.38235V2.20385Z",
    fill: "#EB4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.31201 11.6487H6.67941V10.0692H4.7963V4.35111H3.31201V11.6487ZM7.65983 11.6511H9.14411V4.34869H7.65983V11.6511ZM20.7 4.3748H16.9704V11.6249H20.7V10.0454H18.4547V8.78964H20.5345V7.21011H18.4547V5.95433H20.7V4.3748ZM12.5936 11.7245L13.8439 11.7259L16.2882 4.83303L14.8995 4.27535L13.2155 9.0242L11.5154 4.27393L10.1283 4.83613L12.5936 11.7245Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstliveicon);
export default __webpack_public_path__ + "static/media/estliveicon.d3da621ae0d0695e37d3630298a3db1d.svg";
export { ForwardRef as ReactComponent };